import React, { useEffect, useState } from 'react';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-[200] transition-all duration-500 ${scrolled ? 'bg-black/90 backdrop-blur-md border-b border-gold/15 py-3' : 'bg-transparent py-5'}`} data-id="element-35">
      <div className="container-custom flex items-center justify-between" data-id="element-36">
        <a href="#hero" data-id="element-37">
          <img src="https://i.postimg.cc/VkcMmqSb/logo-284.webp" alt="Reflujo Cero en 72h" className="h-10 w-auto object-contain" data-id="element-38" />
        </a>

        <a href="#oferta" className={`hidden sm:inline-flex items-center justify-center bg-gradient-to-r from-gold to-gold-light text-deep font-bold text-[13px] px-5 py-2 rounded-[4px] transition-all duration-300 hover:scale-105 ${scrolled ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2 pointer-events-none'}`} data-id="element-39">
          Acceder →
        </a>
      </div>
    </header>;
}